import { jsxs as l, jsx as m } from "react/jsx-runtime";
import { clsx as d } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import n from "./roche-container.module.scss.js";
import { ContainerColor as o } from "./roche-container.types.js";
const x = ({
  color: e = o.TRANSPARENT,
  fullWidth: t,
  fullHeight: i,
  extendBackgroundToTop: r,
  extendBackgroundToBottom: a,
  children: c
}) => {
  const s = d(
    n.container,
    e !== o.TRANSPARENT && n["container--colored"],
    n[`container--${e}`],
    t && n["container--full-width"],
    i && n["container--full-height"],
    r && n["container--extended-background"],
    r && a && n["container--extended-background-bottom"]
  );
  return /* @__PURE__ */ l("div", { className: s, children: [
    /* @__PURE__ */ m("div", { className: n["container__gradient-helper"] }),
    c
  ] });
};
export {
  x as RocheUIContainer
};
